import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pwnage?",
  "description": "",
  "published": "2007-05-08T00:00:00.000Z",
  "redirect_from": ["/blog/pwnage/swizec/218"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes sem si ogledal novo epizodo `}<a parentName="p" {...{
        "href": "http://www.purepwnage.com"
      }}>{`Pure Pwnage`}</a>{`. Bila je to prva v novi sezoni in bi bil popolnoma spregledal njen obstoj, Äe bi e bilo za prijazen opomnik v obliki "bulletina" na myspace od samega The Pwnererja. Res je, dodal sem ga med prijatelje na myspace, kaj Äemo.`}</p>
    <p>{`Epizoda je bila dokaj zabavna in moram reÄi, da se je oddaja (?) moÄno poboljšala. Kot kaÅ¾e uporabljajo boljšo opremo, kar malÄek dvigne kvaliteto slike inu zvoka. Zgleda tudi, da se je Kyle nekaj nauÄil v šoli, saj kvaliteta kadrov deluje bolje. Ali pa sem paÄ bil od serije oddaljen predolgo.`}</p>
    <p>{`Kar pa je res graje vedno, pa je dejstvo, da novih epizod veÄ ni moÅ¾no dolnaloÅ¾iti s streÅ¾nika mapak smo jih primorani gledati v streamu naravnost v "priroÄen" flash predvajalnik, ki se vsede v samo stran. ÄŒeprav je to popolnoma v redu za kak youtube, je neprimerno za celotno serijo. Flash za seboj potegne vse preveliko porabo RAM-a inu CPU-ja, kar v svojem jedru niti ni pretirano slabo, vendar pa se mi zdi neprimerno, da moram gledanje uboge nanizanke psovetiti celotno raÄunalo.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      